import { useNavigate } from 'react-router-dom';
import './about.css';



export const About = () => {
    const navigate = useNavigate();


    const registerLink = () => {
        navigate('/register');
    }



    return (
        <div className='main about' >

            <div className='content has-aside '>
                <div className='intro'>
                    <h1>Privacy to Explore.</h1>
                    <p>Flintt is an upcoming social platform designed to connect users to those with compatible interests, prioritising discretion whilst allowing you to explore your desires.</p>
                    <p>Whether you're taking your first step or simply prefer privacy, Flintt is designed for those who move with intention and discretion.</p>
                </div>
                <div className='features'>
                    <h2>Features</h2>
                    <div>
                        <div className='stealth-icon'></div>
                        <div>
                            <strong>Stealth Mode</strong>
                            <p>With one click, hide all images and videos from displaying.</p>
                        </div>
                    </div>
                    <div>
                        <div className='browser-icon'></div>
                        <div>
                            <strong>Desktop and Mobile</strong>
                            <p>Browser based for additional security.</p>
                        </div>
                    </div>
                    <div>
                        <div className='community-icon'></div>
                        <div>
                            <strong>By the Community, For the Community.</strong>
                            <p>Created by an LGBTQ+ team, Flintt recognises the need for safety and discretion.</p>
                        </div>
                    </div>
                    <div>
                        <div className='premium-icon'></div>
                        <div>
                            <strong>Free and Premium Tiers</strong>
                            <p>Unlock the full features of Flintt with a Premium membership.</p>
                        </div>
                    </div>
                </div>
                <div className='signup-button'
                    onClick={registerLink}>
                    <a href="/register" title="Sign up">Sign up</a>
                </div>

            </div>
            <div className='aside'><div></div></div>
        </div>
    )
}